import { getValueWithoutFormat } from "../../../formatters";

export function setupProductForm () {
  // Product details
  const idHiddenInput = document.getElementById("product_id");
  const nameHiddenInput = document.getElementById("product_name");
  const unitAmountHiddenInput = document.getElementById("unit-amount") || document.getElementById("payment-total");
  const providerHiddenInput = document.getElementById("provider");

  return {
    getId () {
      return idHiddenInput.value;
    },
    getName () {
      return nameHiddenInput.value;
    },
    getProvider () {
      return providerHiddenInput.value;
    },
    getUnitAmountValue (formatted = false) {
      return formatted
        ? unitAmountHiddenInput
        : getValueWithoutFormat(unitAmountHiddenInput?.innerText) / 100;
    },
    inputs: {
      idHiddenInput,
      nameHiddenInput,
      unitAmountHiddenInput
    }
  };
}
